import { useEffect, useState } from 'react';

// Falls back to a Pune city-center coordinate when geolocation is denied/unavailable —
// matches the reference design's Pune-focused location picker.
const PUNE_FALLBACK = { lat: 18.5204, lng: 73.8567 };

export function useGeolocation() {
  const [coords, setCoords] = useState(PUNE_FALLBACK);
  const [resolved, setResolved] = useState(false);

  useEffect(() => {
    if (!navigator.geolocation) {
      setResolved(true);
      return;
    }
    navigator.geolocation.getCurrentPosition(
      (position) => {
        setCoords({ lat: position.coords.latitude, lng: position.coords.longitude });
        setResolved(true);
      },
      () => setResolved(true),
      { timeout: 5000 }
    );
  }, []);

  return { coords, resolved };
}
